import { render } from "./GuidesComponent.vue?vue&type=template&id=098c0815&scoped=true"
import script from "./GuidesComponent.vue?vue&type=script&lang=js"
export * from "./GuidesComponent.vue?vue&type=script&lang=js"

import "./GuidesComponent.vue?vue&type=style&index=0&id=098c0815&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098c0815"]])

export default __exports__